module.exports = __webpack_public_path__ + "img/premium-section-background.72052c3.jpg";